(function (app) {

    app.provider("marketingTrackerAgentApi",
        [
            function () {
                this.$get = [
                    "marketingTrackerApiGateway", function (marketingTrackerApiGateway) {
                        var service = {};

                        service.get = function () {
                            return marketingTrackerApiGateway.get("/Agents/Current");
                        }

                        service.getByFigAuth = function (figAuthId) {
                            return marketingTrackerApiGateway.get("/Agents/FigAuth/" + figAuthId);
                        }

                        return service;
                    }
                ];
            }
        ]);
})(window.app); //jshint ignore:line